import { get } from 'lodash'
import moment from 'moment'
import React from 'react'
import { ArrowClockwise } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'
import IconLabel from '../../common/icon-label'

const SeriesLabel = ({
    experience = {},
    size
}) => {
    const { breakpoint, breakpoints } = useViewport()
    const dateFormat = 'MM/DD/YYYY'
    const { startDate, endDate } = get(experience, 'series', {})
    const startLabel = moment(startDate).isValid() ? moment(startDate).format(dateFormat) : '?'
    const endLabel = moment(endDate).isValid() ? moment(endDate).format(dateFormat) : '?'
    return (
        <IconLabel
            size={size}
            icon={ArrowClockwise}
        >
            SERIES RUNS {startLabel} - {endLabel}
        </IconLabel>
    )
}

export default SeriesLabel
